module.exports = __webpack_public_path__ + "fonts/QtNW6+cS.woff";